// extracted by mini-css-extract-plugin
export default {"wrapper":"MessagesList_wrapper__dxSp9","messagesWrapper":"MessagesList_messagesWrapper__V9JUs","messages":"MessagesList_messages__f0g84"};